import { render, staticRenderFns } from "./EventPeriodSelector.vue?vue&type=template&id=7f918a52&scoped=true&"
import script from "./EventPeriodSelector.vue?vue&type=script&lang=js&"
export * from "./EventPeriodSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f918a52",
  null
  
)

/* custom blocks */
import block0 from "./EventPeriodSelector.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f918a52')) {
      api.createRecord('7f918a52', component.options)
    } else {
      api.reload('7f918a52', component.options)
    }
    module.hot.accept("./EventPeriodSelector.vue?vue&type=template&id=7f918a52&scoped=true&", function () {
      api.rerender('7f918a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceEvents/EventPeriodSelector.vue"
export default component.exports